import { jsx as _jsx } from "react/jsx-runtime";
import BarSeries from "./BarSeries";
export const HISTOGRAM_DEFAULTS = {
    baseAt: 0,
    upColor: "#26a69a",
    downColor: "#ef5350",
    opacity: 0.9,
};
/**
 * Chọn màu cột theo dấu so với đường cơ sở. Tách thành hàm thuần để test được
 * mà không cần dựng chart — logic này là toàn bộ giá trị của histogram.
 *
 * Giá trị không hợp lệ (NaN/undefined/không phải số) trả `upColor` **không phải**
 * `downColor`: một cột không có dữ liệu tô màu "giảm" sẽ đọc thành tín hiệu xu hướng
 * không tồn tại.
 */
export function resolveHistogramFill(value, colors) {
    // `Number.isFinite` chứ không phải `!Number.isNaN`: -Infinity < 0 là đúng nên
    // nếu chỉ chặn NaN thì cột vô hạn âm sẽ tô màu "giảm" và đọc thành tín
    // hiệu xu hướng. Giá trị không hữu hạn không phải tín hiệu.
    if (typeof value !== "number" || !Number.isFinite(value))
        return colors.upColor;
    if (value > colors.baseAt)
        return colors.upColor;
    if (value < colors.baseAt)
        return colors.downColor;
    return colors.flatColor ?? colors.upColor;
}
export function HistogramSeries(props) {
    const { baseAt = HISTOGRAM_DEFAULTS.baseAt, upColor = HISTOGRAM_DEFAULTS.upColor, downColor = HISTOGRAM_DEFAULTS.downColor, flatColor, opacity = HISTOGRAM_DEFAULTS.opacity, yAccessor, ...rest } = props;
    const baseOf = (xScale, yScale, datum) => typeof baseAt === "function" ? baseAt(xScale, yScale, datum) : baseAt;
    return (_jsx(BarSeries, { ...rest, yAccessor: yAccessor, opacity: opacity, baseAt: baseOf, fill: (d) => resolveHistogramFill(yAccessor ? yAccessor(d) : undefined, {
            baseAt: baseOf(null, null, d),
            upColor,
            downColor,
            flatColor,
        }) }));
}
export default HistogramSeries;
